/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  GetReceiveNoteFastTrackResponse,
  NormalizedFastTrackItems,
  NormalizedFastTrackIssues,
} from './types';

export const normalizeFastTrackItems = (
  response: GetReceiveNoteFastTrackResponse
): NormalizedFastTrackItems => {
  const items: NormalizedFastTrackItems['items'] = {};
  const itemIds: string[] = [];

  (response?.receiveNoteItems ?? []).forEach((item) => {
    const id = item.receiveNoteItemId;
    itemIds.push(id);
    items[id] = {
      receiveNoteItemId: item.receiveNoteItemId,
      catalogNumber: item.catalogNumber,
      manufacturerId: item.manufacturerId,
      name: item.name,
      quantity: item.quantity,
      unitId: item.unitId,
      quantityLeft: item.quantityLeft,
      isAccepted: item.isAccepted,
      issueIds: item.fastTruckIssues.map((issue) => issue.fastTruckItemId),
    };
  });

  return {itemIds, items};
};

export const normalizeFastTrackIssues = (
  response: GetReceiveNoteFastTrackResponse
): NormalizedFastTrackIssues => {
  const issues: NormalizedFastTrackIssues['issues'] = {};
  const issuesByItem: NormalizedFastTrackIssues['issuesByItem'] = {};

  (response?.receiveNoteItems ?? []).forEach((item) => {
    const issueIds: string[] = [];
    item.fastTruckIssues.forEach((issue) => {
      issues[issue.fastTruckItemId] = issue;
      issueIds.push(issue.fastTruckItemId);
    });
    issuesByItem[item.receiveNoteItemId] = issueIds;
  });

  return {issues, issuesByItem};
};
